<script setup>
import { Head } from '@inertiajs/inertia-vue3';
import MainLayout from '../../Layouts/MainLayout';
import { useQuasar } from 'quasar';
import { computed, defineProps } from 'vue';

const $q = useQuasar();

const props = defineProps({
    perguntasFrequentes: {
        type: Array,
        required: true,
    },
});

const metade = computed(() => Math.ceil(props.perguntasFrequentes.length / 2));
const perguntasColuna1 = computed(() => props.perguntasFrequentes.slice(0, metade.value));
const perguntasColuna2 = computed(() => props.perguntasFrequentes.slice(metade.value));
</script>

<template>
    <Head title="Perguntas frequentes" />
    <MainLayout>
        <q-page>
            <div>
                <div class="flex justify-center">
                    <h1 class="
                          text-center text-primary text-h4 text-bold full-width
                          q-my-md q-pt-lg
                      ">
                        Perguntas frequentes
                    </h1>
                    <h2 class="
                          text-center text-primary text-h5 full-width
                          q-my-md
                      ">
                        Respostas para as dúvidas mais comuns de nossos usuários!
                    </h2>
                </div>
                <div style="min-height: 40vh">
                    <div
                        :class="$q.screen.lt.sm ? 'column' : ''"
                        class="flex"
                    >
                        <div
                            class="flex q-mt-sm"
                            style="flex:1;">
                            <q-expansion-item
                                v-for="(faq, id) in perguntasColuna1"
                                :key="'faq-1-' + id"
                                :label="faq.pergunta"
                                class="full-width"
                                expand-separator
                                header-class="text-primary"
                                icon="mdi-chat-question"
                            >
                                <q-card>
                                    <q-card-section
                                        class="faq-resposta"
                                        v-html="faq.resposta"
                                    />
                                </q-card>
                            </q-expansion-item>
                        </div>
                        <div
                            :class="$q.screen.lt.sm ? '' : 'q-mt-sm'"
                            class="flex"
                            style="flex:1;"
                        >
                            <q-expansion-item
                                v-for="(faq, id) in perguntasColuna2"
                                :key="'faq-2-' + id"
                                :label="faq.pergunta"
                                class="full-width"
                                expand-separator
                                header-class="text-primary"
                                icon="mdi-chat-question"
                            >
                                <q-card>
                                    <q-card-section
                                        class="faq-resposta"
                                        v-html="faq.resposta"
                                    />
                                </q-card>
                            </q-expansion-item>
                        </div>
                    </div>
                </div>
            </div>
        </q-page>
    </MainLayout>
</template>

<style scoped>
.faq-resposta :deep(a) {
    color: inherit;
    text-decoration: underline;
}
</style>
